import React from 'react';
import {AisinoFormItem} from "../../../baseComponent/form";
import {formItemTailLayout} from "../../../constant/css";
import {Select} from "antd";

const Option = Select.Option;

class FormItemSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            optionsData: '',
        };
    }

    render() {
        let children = [];
        if (this.props.options) {
            this.props.options.map((child) => {
                    return (
                        children.push(<Option key={child.name} value={child.value}>{child.name}</Option>)
                    )
                }
            )
        }
        let styleBg = false
        this.props.rules?this.props.rules.forEach(item=>{
            if(item.required){
                styleBg = item.required
            }
        }):""
        return (
            <div className={styleBg?"selectBg":""}>
                <AisinoFormItem  {...formItemTailLayout}
                                {...this.props} onChange={this.props.onChangeItem}>
                    <Select
                        {...this.props}
                        style={{...this.props.style,background:styleBg?"#ffffe6":""}}
                        placeholder="Please Select"
                    >
                        [...children]
                    </Select>
                </AisinoFormItem>
            </div>
            
        );
    }
}

export default FormItemSelect;